var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame208(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 41,
    viewBox: "0 0 430 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2805_664)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2805_664",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H430V41H0V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 55V0H58.5V55H33.5ZM50.3726 22.2696H45.6863H41C41 20.8774 42.8825 18.6029 45.6863 18.6029C48.4902 18.6029 50.3726 20.8774 50.3726 22.2696ZM41 23.4559L45.6863 33.2336L50.3726 23.4559H41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 180,
    x2: 104,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 180,
    x2: 152,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.5 55V0H227.5V55H202.5ZM219.373 22.2696H214.686H210C210 20.8774 211.882 18.6029 214.686 18.6029C217.49 18.6029 219.373 20.8774 219.373 22.2696ZM210 23.4559L214.686 33.2336L219.373 23.4559H210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273,
    y1: 180,
    x2: 273,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321,
    y1: 180,
    x2: 321,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.5 55V0H396.5V55H371.5ZM388.373 22.2696H383.686H379C379 20.8774 380.882 18.6029 383.686 18.6029C386.49 18.6029 388.373 20.8774 388.373 22.2696ZM379 23.4559L383.686 33.2336L388.373 23.4559H379Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4H430V-4H0V4ZM430 37H0V45H430V37Z",
    fill: "white",
    mask: "url(#path-1-inside-1_2805_664)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2805_664"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H430V41H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame208);
export default __webpack_public_path__ + "static/media/Frame 208.ffd25071ad3079c61cce5c5a3bafbebb.svg";
export { ForwardRef as ReactComponent };